import { render, staticRenderFns } from "./limite-plan.vue?vue&type=template&id=092de513&"
import script from "./limite-plan.vue?vue&type=script&lang=js&"
export * from "./limite-plan.vue?vue&type=script&lang=js&"
import style0 from "./limite-plan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports